
export const common = {
  // Navigation
  home: 'الرئيسية',
  services: 'الخدمات',
  about: 'من نحن',
  gallery: 'المعرض',
  contact: 'اتصل بنا',
  reserve: 'احجز',
  
  // Buttons
  bookNow: 'احجز الآن',
  learnMore: 'اعرف المزيد',
  whatsapp: 'واتساب',
  close: 'إغلاق',
  
  // Hero Section
  heroTitle: 'سافر مع',
  heroTitleHighlight: 'الأناقة',
  heroDescription: 'اكتشف المغرب وكندا بطريقة مختلفة مع خدمة النقل المميزة لدينا. الراحة والأمان والضيافة الأصيلة.',
  
  // Services
  servicesTitle: 'خدماتنا المميزة',
  servicesDescription: 'مجموعة كاملة من خدمات النقل السياحي لتلبية جميع احتياجات سفرك، من النقل البسيط إلى الجولات الأكثر حصرية.',
  
  // About
  aboutTitle: 'قصتنا',
  aboutDescription1: 'لأكثر من 10 سنوات، نقدم تجربة نقل سياحي استثنائية في المغرب وكندا. شغفنا بالضيافة المغربية وخبرتنا الميدانية تسمح لنا بخلق رحلات لا تُنسى.',
  aboutDescription2: 'سواء كنت مسافر أعمال أو عائلة في إجازة أو مجموعة من الأصدقاء تبحث عن المغامرة، نضع خبرتنا في خدمتك لجعل كل كيلومتر متعة.',
  
  // Values
  security: 'الأمان',
  securityDesc: 'مركبات مُصانة وسائقون معتمدون لراحة بالك.',
  punctuality: 'الدقة',
  punctualityDesc: 'احترام المواعيد والالتزامات لخدمة موثوقة.',
  hospitality: 'الضيافة',
  hospitalityDesc: 'ترحيب حار وخدمة شخصية في التقليد المغربي.',
  excellence: 'التميز',
  excellenceDesc: 'السعي المستمر للكمال في كل تفصيل من خدماتنا.',
  
  // Testimonials
  testimonialsTitle: 'شهادات العملاء',
  testimonialsDescription: 'اكتشف ما يقوله عملاؤنا عن تجربتهم مع خدمة النقل المميزة لدينا.',
  satisfiedClients: 'عملاء راضون',
  destinations: 'وجهات',
  customerService: 'خدمة العملاء',
  
  // Reservation
  reservationTitle: 'احجز وسيلة النقل الخاصة بك',
  reservationDescription: 'املأ النموذج أدناه للحصول على عرض أسعار مخصص أو احجز خدمة النقل المميزة مباشرة.',
  fullName: 'الاسم الكامل',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  desiredService: 'الخدمة المطلوبة',
  selectService: 'اختر خدمة',
  departureDate: 'تاريخ المغادرة',
  departureTime: 'وقت المغادرة',
  passengers: 'الركاب',
  passenger: 'راكب',
  departureLocation: 'مكان المغادرة',
  destination: 'الوجهة',
  message: 'رسالة أو طلبات خاصة',
  messageDescription: 'صف احتياجاتك المحددة أو تفضيلاتك أو أسئلتك...',
  sendRequest: 'إرسال الطلب',
  sending: 'جاري الإرسال...',
  directContact: 'اتصال مباشر',
  availability: 'التوفر',
  quickResponse: 'استجابة سريعة',
  quickResponseDescription: 'نحن ملتزمون بالرد عليك في أقرب وقت ممكن:',
  whatsappResponse: 'واتساب: رد فوري',
  emailResponse: 'البريد الإلكتروني: خلال ساعتين',
  freeQuote: 'عرض أسعار مجاني وبدون التزام',
  
  // Contact
  contactTitle: 'اتصل بنا',
  contactDescription: 'فريقنا في خدمتك للإجابة على جميع أسئلتك ومساعدتك في تنظيم رحلاتك.',
  sendMessage: 'أرسل لنا رسالة',
  subject: 'الموضوع',
  selectSubject: 'اختر موضوعاً',
  quoteRequest: 'طلب عرض أسعار',
  serviceInfo: 'معلومات عن خدماتنا',
  complaint: 'شكوى',
  partnership: 'اقتراح شراكة',
  other: 'أخرى',
  messageRequired: 'الرسالة',
  messageContactDescription: 'صف طلبك بالتفصيل...',
  sendMessageBtn: 'إرسال الرسالة',
  ourCoordinates: 'معلومات الاتصال',
  address: 'العنوان',
  telephone: 'الهاتف',
  hours: 'ساعات العمل',
  officeHours: 'المكتب: 8 صباحاً - 8 مساءً',
  followUs: 'تابعنا',
  ourLocation: 'موقعنا',
  
  // Form Messages
  successMessage: 'تم إرسال طلبك بنجاح! سنتواصل معك قريباً.',
  successContactMessage: 'تم إرسال رسالتك بنجاح! سنرد عليك قريباً.',
  errorMessage: 'حدث خطأ. يرجى المحاولة مرة أخرى أو الاتصال بنا مباشرة.',
  charactersLimit: 'حرف',
  
  // Footer
  footerDescription: 'شريكك الموثوق للنقل السياحي الفاخر في المغرب وكندا. اكتشف وجهاتنا بأناقة وراحة.',
  ourServices: 'خدماتنا',
  copyright: '© 2024 هافي تورز. جميع الحقوق محفوظة.',
  poweredBy: 'مدعوم من ريدي',
  
  // Common
  yearsExperience: 'سنوات من الخبرة',
  includedInService: 'مشمول في الخدمة',
  reserveThisService: 'احجز هذه الخدمة',
  chatOnWhatsApp: 'تحدث على واتساب',
  notAvailableYet: 'غير متوفر حتى الآن',
  required: '*',
  placeholderName: 'اسمك الكامل',
  placeholderEmail: 'your@email.com',
  placeholderPhone: '+212 6XX XXX XXX',
  placeholderDeparture: 'المطار، الفندق، العنوان...',
  placeholderDestination: 'المدينة، الموقع السياحي...'
};
